import { render, staticRenderFns } from "./module.vue?vue&type=template&id=d152a6f0&scoped=true&"
import script from "./module.vue?vue&type=script&lang=js&"
export * from "./module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d152a6f0",
  null
  
)

export default component.exports